import { apiGet, apiPut, ApiCallParams } from "@/services/baseService";
import {
  UserDetailsVm,
  NotificationSettings,
  ForgotChangePasswordVm
} from "./domain";
import requestToApi from "@/services/baseService";

export async function isAlive() {
  const response = await requestToApi("/api/accounts/is_alive/", "post", true);
  return response;
}

export async function getMyAccountDetailsApi() {
  const response = await apiGet<UserDetailsVm>(`/api/accounts/me`);
  if (response.data) {
    const result: UserDetailsVm = response.data;
    return result;
  }
  return undefined;
}

export async function putAccountNotificationSettingsApi(
  params: ApiCallParams<NotificationSettings>
) {
  const response = await apiPut("/api/accounts/settings/notifications", {
    payload: params
  });

  return response.data;
}

export async function postCardNumberToResetPasswordSendSmsApi(
  params: ApiCallParams<number>
) {
  const response = await requestToApi(
    "/api/accounts/reset_password/sms/send",
    "post",
    false,
    params
  );

  return response;
}

export async function postNewPasswordDataToChangePasswordApi(
  params: ApiCallParams<ForgotChangePasswordVm>
) {
  const response = await requestToApi(
    "/api/accounts/reset_password/sms/set",
    "post",
    false,
    params
  );

  return response;
}
